import { render, staticRenderFns } from "./SharerRateTiers.vue?vue&type=template&id=4c50f1be&scoped=true"
import script from "./SharerRateTiers.vue?vue&type=script&lang=js"
export * from "./SharerRateTiers.vue?vue&type=script&lang=js"
import style0 from "./SharerRateTiers.vue?vue&type=style&index=0&id=4c50f1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c50f1be",
  null
  
)

export default component.exports